import React from 'react'
import './share.css'

const PostShare = ({link, tooltip, classObj, icon}) => {

      return (
            <a className={`btn_post__share ${classObj}`} href={link} target="_blank" rel="noreferrer" data-tooltip={tooltip}>{icon}</a>
      )
}

export default PostShare
